import React from 'react';
import {
    TermForm,
} from '../../../../../../slices/marketplace/loi-form/term-form';
import { TermsFormSelect } from './TermsFormSelect';
import {
    getOptionsForAnswerType,
    LoiFormAnswerType,
    REAL_PROPERTY_OPTIONS,
} from '../../../../../../slices/marketplace/loi-form/loi-form-answer-type.enum';

export interface TermsFormPropertyPurchasedBlockProps {
    termForm: TermForm;
    readOnly?: boolean;
    onChange?: (form: TermForm) => void;
    errors?: Set<string>;
}

export const TermsFormPropertyPurchasedBlock: React.FC<TermsFormPropertyPurchasedBlockProps> = ({
    termForm,
    readOnly,
    onChange,
    errors,
}) => {
    const update = (patch: Partial<TermForm>) => {
        onChange?.({ ...termForm, ...patch });
    };

    return (
        <div className="terms-form-detail-block terms-form-summary-layout terms-form-section-underlined terms-form-property-purchased-block">
            <div className="terms-form-column-headers">
                <div className="terms-form-col-item terms-form-col-header">
                    Property Purchased
                </div>
                <div className="terms-form-col-value terms-form-col-header-right">
                    Values
                </div>
            </div>
            <div className="terms-form-form-content">
                <div className="terms-form-summary-row">
                    <div className="terms-form-col-item">
                        Practice Property Purchased
                    </div>
                    <div className="terms-form-col-value">
                        <TermsFormSelect
                            value={
                                termForm.propertyPurchased?.practicePropertyPurchased ?? ''
                            }
                            options={getOptionsForAnswerType(
                                    LoiFormAnswerType.PurchaseAgreementType
                                ).map((o) => o.value)}
                            disabled={readOnly}
                            invalid={errors?.has('practicePropertyPurchased')}
                            onChange={(e) =>
                                update({
                                    propertyPurchased: {
                                        ...termForm.propertyPurchased,
                                        practicePropertyPurchased: e,
                                    },
                                })
                            }
                            aria-label="Practice Property Purchased"
                        />
                    </div>
                </div>
                <div className="terms-form-summary-row">
                    <div className="terms-form-col-item">
                        Practice Real Property Included
                    </div>
                    <div className="terms-form-col-value">
                        <TermsFormSelect
                            value={
                                termForm.propertyPurchased
                                    ?.practiceRealPropertyInclude ?? ''
                            }
                            options={REAL_PROPERTY_OPTIONS.map((o) => o.value)}
                            disabled={readOnly}
                            invalid={errors?.has('practiceRealPropertyInclude')}
                            onChange={(e) =>
                                update({
                                    propertyPurchased: {
                                        ...termForm.propertyPurchased,
                                        practiceRealPropertyInclude: e,
                                    },
                                })
                            }
                            aria-label="Practice Real Property Included"
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};
